export default "__VITE_ASSET__DBZ4K4G$__"